import { Controller } from "@hotwired/stimulus"

import flatpickr from "flatpickr"
import { Estonian } from "flatpickr/dist/esm/l10n/et.js"

export default class extends Controller {
  static targets = ["calendar", "selectedDates"]
  static values = { academicYearStart: String,
                    academicYearEnd: String,
                    current: Array,
                    locale: String }

  connect() {
    const academicStart = new Date(this.academicYearStartValue)
    const academicEnd = new Date(this.academicYearEndValue)
    const rangeStart = new Date(academicStart)
    rangeStart.setFullYear(rangeStart.getFullYear() - 1)
    const rangeEnd = new Date(academicEnd)
    rangeEnd.setFullYear(rangeEnd.getFullYear() + 1)
    const currentHolidays = this.currentValue.map(date => new Date(date))
    this.flatpickr = flatpickr(this.calendarTarget, {
      mode: "multiple",
      defaultDate: currentHolidays,
      minDate: rangeStart,
      maxDate: rangeEnd,
      inline: true,
      noCalendar: false,
      static: false,
      showMonths: 3,
      time_24hr: true,
      locale: {
        ...(this.localeValue === "et" ? Estonian : {}),
        dateFormat: "Y-m-d",
        firstDayOfWeek: 1
      },
      onChange: (selectedDates) => {
        this.updateSelectedDates(selectedDates)
      }
    })

    if (currentHolidays.length > 0) {
      this.updateSelectedDates(currentHolidays)
    }
  }

  updateSelectedDates(dates) {
    this.selectedDatesTarget.value = JSON.stringify(dates.map(isoDate))
  }

  disconnect() {
    if (this.flatpickr) {
      this.flatpickr.destroy()
    }
  }
}

// The wire format the server parses (Date.parse), in the browser's own
// time zone so a picked day is never shifted by UTC conversion.
function isoDate(date) {
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  return `${date.getFullYear()}-${month}-${day}`
}
